import Nullstack from 'nullstack';
export default function IconRainbowOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-rainbow-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 17c0 -5.523 -4.477 -10 -10 -10c-.308 0 -.613 .014 -.914 .041m-3.208 .845a10.002 10.002 0 0 0 -5.878 9.114"
  }), "   ", Nullstack.element("path", {
    d: "M11.088 11.069a6.001 6.001 0 0 0 -5.088 5.931"
  }), "   ", Nullstack.element("path", {
    d: "M14 17a2 2 0 1 0 -4 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}